import React, { useState, useEffect, Fragment , useCallback} from "react";
import Location from "components/sales/formSection/location/locationOnboarding";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { useContext } from "react";
import BulkUpload from "components/sales/bulkUpload/bulkUpload";
import Layout from 'components/sales/layout/layout';
import FormSection from 'components/sales/formSection/formSectionNew';
import SearchLocation from 'components/sales/searchLocation/searchLocation';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { useParams } from 'react-router-dom';
import { toast } from "react-toastify";
import { isAddLocationSuccess } from "services/redux/sales/projectOnboarding/action";
import axios from "axios";
import Config from "services/config/config";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
const AddClientLocation = ({
                        match,
                        history,
                        locationCity,
                        cities,
                        locationZone,
                        zones,
                        locationArea,
                        areas,
                        locationType,
                        locTypesData,
                        locationState,
                        locationPinCode,
                        pincodeData,
                        getCurrentLocation,
                        latlng,
                        lat,
                        lng,
                        currentLocation,
                        toastMsg,
                        addLocationDetailsData,
                        checkGstNumber
                    }) => {
    const corporateInput = {
        location: null,
        type:null,
        lead_id:null
    };
    const inputs = {
        lat: '',
        lng: '',
        };
    const [formData, setData] = useState(inputs);
    const {parameter} = useParams();
    const { baseUrl } = useContext(BaseUrl);
    const [isModal, setIsModal] = useState(false);
    const [isModalPrev, setIsModalPrev] = useState(false);
    const [corporateData, setCorporateData] = useState(corporateInput);
    const [isFiled, setIsFiled] = useState(false);
    const [isbulk, setIsbulk] = useState(false);
    const [isUploaded, setIsuploaded] = useState(false);
    const [bulkFile, setBulkFile] = useState(null);
    const [isDefalut, setIsDefalut] = useState(false);
    const [isSupply, setIsSupply] = useState(false);
    const [isApt, setIsApt] = useState(false);
    const [dropdown, setDropDown] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [showAddForm, setAddForm] = useState(false);
    const [isEnable, setIsEnable] = useState(true);
    const [type, setType] = useState(null);
    const [leadId, setLeadId] = useState(null);
    const [clientId, setClientId] = useState(null);
    const [contractId, setContractId] = useState(null);
    const [prevAddress, setPrevAddress] = useState(null);
    const [clientPan, setClientPan] = useState("");
    const [clientGst, setClientGst] = useState("");
    const [registeredName, setRegisteredName] = useState('');
    const [isGstValidated, setIsGstValidated] = useState(false);
    const [isGstSelected, setIsGstSelected] = useState(false);
    const [addressOptions, setAddressOptions] = useState([]);
    const [isAddressSelected, setIsAddressSelected] = useState(false);
    const [selectedAddress,setSelectedAddress] = useState(null);
    const [gstData,setGstData] = useState([]);
    const [isInputError, setIsInputError] = useState({
        latError: false,
        longError: false,
        pinError: false,
        crl: false,
        isPinNotFound: false,
    });

    const [optOption, setOptOption] = useState({
        address2: '',
        currentLocation: '',
    });

    const handleLocSubmit = (val) => {
        setCorporateData({ ...corporateData, location: val });
        setIsDefalut(false);
    };
    
    const handleCurrentLocationChange = (value) => {
        setOptOption({ ...optOption, currentLocation: value });
        localStorage.setItem('currentLocation', value);
    };

    useEffect(()=>{
        if (selectedAddress?.value !== 'Other') {
            const selected = addressOptions.find(opt => opt.id === selectedAddress?.id);
            if (selected) {
                setGstData([{
                    ...gstData[0],
                    state_name: selected.state,
                    geo_city_id: selected.city_id,
                    geo_state_id: selected.state_id,
                    pincode_id: selected.pincode_id,
                    city_name: selected.city,
                    pincode: selected.pincode,
                    address1: selected.addressLine1,
                    address2: selected.addressLine2,
                    isLat: formData.lat,
                    isLong: formData.lng
                }]);
            }
        }
        else{
            setGstData([{
                ...gstData[0],
                state_name: '',
                geo_city_id: '',
                geo_state_id: '',
                pincode_id: '',
                city_name: '',
                pincode: '',
                address1: '',
                address2: '',
                isLat: formData.lat,
                isLong: formData.lng
            }]);
        }
    },[selectedAddress])

    useEffect(()=>{
        setIsGstValidated(false);
    },[clientGst])

    const handleCheckGst = useCallback(async () => {
        let cancelled = false;
        setIsLoading(true);
      
        try {
          const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
          if (!clientGst || clientGst.length !== 15 || !gstRegex.test(clientGst)) {
            toast.error("Invalid GST number");
            setIsLoading(false);
            return;
          }
      
          const response = await axios.get(`${Config.client.getDetailsByGst}?gst=${clientGst}`);
          const result = response?.data?.response;
      
          if (!cancelled && result?.status) {
            const addressList = result.data?.address ?? [];
            setAddressOptions(addressList);
            setSelectedAddress(null); 
            setIsAddressSelected(false);
            setIsGstValidated(true);
          } else if (!cancelled) {
            toast.error(result?.message || "GST validation failed");
            setIsGstValidated(false);
          }
        } catch (error) {
          if (!cancelled) {
            toast.error("Invalid or Inactive GST");
          }
        } finally {
          if (!cancelled) setIsLoading(false);
        }
      
        return () => {
          cancelled = true;
        };
      }, [clientGst]);

    useEffect(() => {
       if(match.params.type) {
            setIsLoading(true);
            setType(match.params.type); 
            setLeadId(match.params.lead_id); 
            setClientId(match.params.client_id);
            setContractId(match?.params?.contract_id)
            setIsLoading(false); 
       }
    },[match.params.type,match.params.lead_id]);

    const handlePrevClient = () => {
        (async () => {
            if(clientGst){
                setIsLoading(true);
                const res = await checkGstNumber(clientId,clientGst)
                setIsLoading(false);
                if(res?.client_gst != undefined){
                    setPrevAddress(res)
                    setIsModalPrev(true)
                }else{
                    handleSubmit()
                }
            } else
            {
                handleSubmit()
            }


        })();
    }

    const handleModalClose = async () => {
        setIsModalPrev(false)
      }

    const handleSubmit = () => {
        setIsModalPrev(false)
        // if(clientGst == "") {
        //     toast.warning('Please fill GST number.');
        //     return false;
        // }
        // if(clientPan != "" && clientGst == "") {
        //     toast.warning('Please fill client GST number.');
        //     return false;
        // }

         const {
            location
        } = corporateData;

        let isLocationEmpty = false;

        if(location == '' || location==null || location.address1 == '' || location.address1 == null ||
            location.area == '' || location.area == null ||
            location.city == '' || location.city == null ||
            location.zone == '' || location.zone == null ||
            location.geoCity == '' || location.geoCity == null ||
            location.geoState == '' || location.geoState == null ||
            location.pinCode == '' || location.pinCode == null ||
            location.isLat == '' || location.isLat == null ||
            location.isLong == '' || location.isLong == null
        ){
            isLocationEmpty = true;
        }

        if (isLocationEmpty) { 
            toast.warning('Please fill location details.');
            return false;
        }
         else {
            setIsFiled(false);
            (async () => {
                setIsLoading(true);
                const res = await addLocationDetailsData({
                    location,
                    type,
                    leadId,
                    clientId,
                    clientPan,
                    clientGst,
                    registeredName,
                    contractId,
                });
                setIsLoading(false);
                localStorage.removeItem("currentLocation");
                if (isAddLocationSuccess(res)) {
                    // toast.success('Address added successfully.');
                    // history.push(`${baseUrl}/client-list`);
                    setIsModal(true);
                } else {
                    // toast.error('Something went wrong, Please try again.');
                }
            })();
        }
    };
    const handleFileChange = (val) => setBulkFile(val);

    const headerBtns = () => {
        return (
            <Fragment>
                <Button onClick={() => setIsbulk(true)} className="btn btn-transparent">
                    {localization.bulkUpload}
                </Button>
            </Fragment>
        );
    };

    const handleCurrentLocationBlur = (latlng = null) => {
        if (latlng !== null && latlng !== undefined) {
          const { lat, lng } = latlng;
          setData({ ...formData, lat: lat, lng: lng });
          setIsEnable(true);
        }
        if (latlng === null) {
          setIsEnable(false);
          // setlocationData({ ...locationData, isLat: "", isLong: "" });
        }
      };

    const handleModalHide = () => {
        //
    }

    return (
        <Layout
            title={localization.addAddress}
            // Buttons={headerBtns}
            //className={isFiled ? 'requiredFileds' : ''}
            isGoback
            isLoading={isLoading}
            //linkUrl={`${baseUrl}/finance-business-list`}
        >   
        <FormSection title={localization.searchLocation}>
        <div className="row">
            <div className='col-md-3'>
              <SearchLocation
                handleCurrentLocationBlur={handleCurrentLocationBlur}
                isError={isInputError.crl}
                value={optOption.currentLocation}
                handleCurrentLocationChange={handleCurrentLocationChange}
              />
            </div>
            <div className="col-md-3 col-sm-12">
                <ConstantInput
                    value={formData.lat}
                    label={localization.lat}
                    errorMsg={localization.requiredLatitude}
                    type="text"
                    required
                    handleChange={(value) => setData({ ...formData, lat: value })}
                    isStarRequired={true}
                    fullWidth
                />
            </div>
            <div className="col-md-3 col-sm-12">
                <ConstantInput
                    value={formData.lng}
                    label={localization.lng}
                    errorMsg={localization.requiredLongitude}
                    type="text"
                    required
                    handleChange={(value) => setData({ ...formData, lng: value })}
                    isStarRequired={true}
                    fullWidth
                />
            </div>
        </div>
        
    </FormSection>
    <FormSection title={localization.registeredName}>
        <div className="row">
            <div className="col-md-12 col-sm-12">
                <ConstantInput
                    value={formData.registered_name}
                    label={localization.registeredName}
                    //errorMsg={localization.requiredLatitude}
                    type="text"
                    required
                    handleChange={(value) => setRegisteredName(value)}
                    //isStarRequired={true}
                    fullWidth
                />
            </div>
        </div>  
    </FormSection>
    <FormSection title={localization.gstDetails}>
        <div className="row">
            {/* <div className="col-md-6 col-sm-12">
                <ConstantInput
                    value={clientPan}
                    label={localization.panNumber}
                    errorMsg={localization.required}
                    type="text"
                    //required
                    handleChange={(value) => setClientPan(value)}
                    //isStarRequired={true}
                    fullWidth
                />
            </div> */}
            <div className='col-md-6'>
                <DropDownInput
                    data={[{ id: 1, name: "Yes" }, { id: 2, name: "No" }]}
                    label={localization.gstConfirmation}
                    required
                    getIdValue={(val) => {
                        setIsGstSelected(val.id);
                    }}
                    isStarRequired={true}
                />
            </div>
            {isGstSelected==1 &&
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    value={clientGst}
                    label={localization.gstNumber}
                    errorMsg={localization.requiredgstNumber}
                    type="text"
                    //required
                    handleChange={(value) => 
                        setClientGst(value)
                    }
                    isStarRequired={isGstSelected == 1 ? true : false}
                    fullWidth
                />
                
                {!isGstValidated && 
                    <>
                    <div className='col-md-6'>
                        <div className="form-group">
                        <a className="btn btn-theme mb-2 btn-sm" onClick={handleCheckGst}>
                            Check GST
                        </a>
                        </div>
                    </div>
                    </>
                }

            </div>
            }
            
            {(isGstSelected == 1 && isGstValidated) &&
                <div className='col-md-6'>
                    <DropDownInput
                        data={addressOptions}
                        label="Select address"
                        required
                        getIdValue={(val) => {
                            if (val) {
                                setSelectedAddress(val);
                                setIsAddressSelected(true);
                            } else {
                                setSelectedAddress(null);
                                setIsAddressSelected(false);
                            }
                        }}
                        isStarRequired={true}
                    />
                </div>
            }
        </div>
    </FormSection>
    {((isAddressSelected && isGstValidated) || isGstSelected==2)&& 
    <Location
        locationCity={locationCity}
        cities={cities}
        locationZone={locationZone}
        zones={zones}
        locationArea={locationArea}
        areas={areas}
        locationType={locationType}
        locTypesData={locTypesData}
        handleValue={handleLocSubmit}
        locationState={locationState}
        locationPinCode={locationPinCode}
        pincodeData={(isGstSelected==1 && selectedAddress?.value!='Other') ? gstData : pincodeData}
        getCurrentLocation={getCurrentLocation}
        latlng={latlng}
        toastMsg={toastMsg}
        isDefalut={isDefalut}
        lat={formData.lat}
        lng={formData.lng}
        currentLocation={currentLocation}
        gstPinCode={isGstSelected==1 && selectedAddress?.value!='Other'}
    />
    } 
    <Fragment>
        <div className="btn-group col-2">
            <Button
                onClick={handlePrevClient}
                className="mt-4"
            >
                <div className="">
                    {localization.submitDtl}
                </div>
            </Button>
        </div>
    </Fragment>
    <ModalPop
        title={localization.success}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
    >
    <div className="text-center">
        <div className="success">
            <img src={Images?.tick} alt="" />
        </div>
        {contractId ? 
          <>
          <h5>{`Client address saved`}</h5>
          <button 
                onClick={() => window.history.back()} 
                className="btn btn-primary mb-4 flex items-center"
            >
                Go Back <img src={Images?.ArrowRight} alt="" />
          </button>
          </>
        : 
        <>
          <h5>{`Client address saved`}</h5>
            <Link
                to={`${baseUrl}/client-list`}
                className="btn btn-primary mb-4"
            >
                Go Back <img src={Images?.ArrowRight} alt="" />
          </Link>
        </>
        }
    </div>
    </ModalPop>


    <ModalPop
                title={localization.conf}
                show={isModalPrev}
                // handleModalHide={handleModalHide}
                keyboard
                backdrop
              >
              <div className="text-left ml-5">
                <h4>An address for this state / GST already exists for this Client:</h4><br/>
                <div className="row" >
                  <div className="col-md-6 infoModal">
                    <span>Address Line 1</span> <p>
                    {prevAddress?.address_line_1 !== undefined ? prevAddress?.address_line_1 : ''}
                    </p>
                  </div>
                  <div className="col-md-6 infoModal">
                    <span>Address Line 2</span> <p>
                    {prevAddress?.address_line_2 !== undefined ? prevAddress?.address_line_2 : ''}
                    </p>
                  </div>
                </div>
                <div className="row" >
                  <div className="col-md-6 infoModal">
                    <span>City</span> <p>
                      {prevAddress?.city_name !== undefined ? prevAddress?.city_name : ''}
                    </p>
                  </div>
                  <div className="col-md-6 infoModal">
                    <span>State</span> <p>
                      {prevAddress?.state_name !== undefined ? prevAddress?.state_name :''}
                    </p>
                  </div>
                </div>
                <div className="row" >
                  <div className="col-md-6 infoModal">
                    <span>Pin Code</span> <p>{prevAddress?.pincode !== undefined  ? prevAddress?.pincode : ''}</p>
                  </div>
                  <div className="col-md-6 infoModal">
                    <span>Client GST</span> <p>
                    {prevAddress?.client_gst !== undefined  ? prevAddress?.client_gst : ''}
                    </p>
                  </div>
    
                </div>
                <p className="note">
                    Are you sure you want to add a new address for the same GST/State?
                </p>
    
                <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6">
                <div className="actions">
                  <Button onClick={handleModalClose} className="btn btn-danger btn-sm">
                    {`No, Return`}
                  </Button>
                  <Button onClick={handleSubmit} className="btn-sm">
                    {`Yes, Add new address`}
                  </Button>
                </div>
                </div>
                </div>
                  
              </div>
            </ModalPop>
</Layout>    
 );
};

export default AddClientLocation;
